import { render, staticRenderFns } from "./ServiceConcept.vue?vue&type=template&id=429264f9&scoped=true&"
import script from "./ServiceConcept.vue?vue&type=script&lang=js&"
export * from "./ServiceConcept.vue?vue&type=script&lang=js&"
import style0 from "./ServiceConcept.vue?vue&type=style&index=0&id=429264f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429264f9",
  null
  
)

export default component.exports